import { QueryFunctionContext } from 'react-query';
import { SECOND_API } from '../api';

export function getSubscriptions({ signal }: QueryFunctionContext) {
    return SECOND_API.get(SECOND_API.PATH.getSubscriptions, { signal }).then((res) => res.data);
}

export function getSubscriptionSubscribers({ signal }: QueryFunctionContext) {
    return SECOND_API.get(SECOND_API.PATH.getSubscriptionSubscribers, { signal }).then((res) => res.data);
}

export function getSubscriptionDailyStats({ signal, queryKey }: QueryFunctionContext) {
    const from: string = queryKey && queryKey[1] && typeof queryKey[1] === 'string' ? queryKey[1] : '';
    const to: string = queryKey && queryKey[2] && typeof queryKey[2] === 'string' ? queryKey[2] : '';
    return SECOND_API.get(SECOND_API.PATH.getSubscriptionDailyStats(from, to), { signal }).then((res) => res.data);
}

export function createSubscription(data: any) {
    return SECOND_API.post(SECOND_API.PATH.createSubscription, data).then((res) => res.data);
}

export function updateSubscription(data: any) {
    const id = data.id;
    delete data.id;
    return SECOND_API.put(SECOND_API.PATH.updateSubscription(id), data).then((res) => res.data);
}
